import { maybeUseLocalUrl } from '../../utils/API';
import { getPortalId } from '../../utils/getPortalId';
const ONBOARDING_REFERRER_TASK = 'onboarding_referrer_task';
const ONBOARDING_REFERRER_GROUP = 'onboarding_referrer_group';
const ONBOARDING_REFERRER_SOURCE = 'onboarding_referrer_source';
const ONBOARDING_PARAMS_TO_PRESERVE = [ONBOARDING_REFERRER_TASK, ONBOARDING_REFERRER_GROUP, ONBOARDING_REFERRER_SOURCE];
export function delayUntilIdle(callback) {
  const delay = window.requestIdleCallback || window.setTimeout;
  const delayOptions = delay === window.requestIdleCallback ? {
    timeout: 5000
  } : 0;
  delay(callback, delayOptions);
}
function insertRootElement(element) {
  const nav = document.getElementById('hs-nav-v4');
  if (nav instanceof HTMLElement && nav.parentNode) {
    nav.parentNode.insertBefore(element, nav);
  }
}
export function getFrameSrc() {
  const onboardingBannerUrl = `${maybeUseLocalUrl({
    localOverrideKey: 'ONBOARDING_TOURS_BANNER_ENV'
  })}/guide-onboarding-tours/${getPortalId()}`;
  const urlSearchParams = new URLSearchParams(window.location.search.slice(1));
  const queryParams = ONBOARDING_PARAMS_TO_PRESERVE.reduce((preservedParams, potentialParam) => {
    const maybeParamValue = urlSearchParams.get(potentialParam);
    if (maybeParamValue) {
      preservedParams.push(`${potentialParam}=${maybeParamValue}`);
    }
    return preservedParams;
  }, []);
  return `${onboardingBannerUrl}${queryParams.length ? `?${queryParams.join('&')}` : ''}`;
}

// Create onboarding-tours banner iframe
export function createFrameElement() {
  const frameElement = document.createElement('iframe');
  frameElement.id = 'onboarding-tours-banner-frame';
  frameElement.frameBorder = '0';
  frameElement.src = getFrameSrc();
  return frameElement;
}
function createRootElement() {
  // Create iframe container block element
  const blockElement = document.createElement('div');
  blockElement.id = 'onboarding-tours-banner';

  // Create and append iframe to container
  const frameElement = createFrameElement();
  blockElement.style.display = 'none';
  blockElement.appendChild(frameElement);
  return blockElement;
}
export function insertOnboardingBanner() {
  const rootElement = createRootElement();
  insertRootElement(rootElement);
}
export function isInOnboardingSession() {
  const isHandholdingEnabledFromStorage = window.sessionStorage && window.sessionStorage.getItem('ONBOARDING_TOURS_GUIDE');
  const urlSearchParams = new URLSearchParams(window.location.search.slice(1));
  return isHandholdingEnabledFromStorage || urlSearchParams.get(ONBOARDING_REFERRER_TASK);
}

/**
 * Utility functions for checking if an `onboarding-tour` is currently active.
 * Since `onboarding-tours` is independent from `nav-onboarding-tours`
 * we need to check if an `onboarding-tour` is currently active.
 *
 * Copied from `onboarding-tours`:
 * https://git.hubteam.com/HubSpot/onboarding-tours/blob/5e58a55f02638f56c7b483c9fb640a8b9b4047ec/static/js/util/activeTour.ts
 */

const TOUR_ID = 'tourId';
const ONBOARDING_TOUR_ID = 'onboardingTourId';
const ONBOARDING_NEXT_TOUR_KEY = 'ONBOARDING_NEXT_TOUR';
export const getTourIdFromQueryParams = () => {
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams.get(TOUR_ID) || searchParams.get(ONBOARDING_TOUR_ID);
};
const isStateExpired = expires => {
  return expires !== undefined && expires < Date.now();
};
const getLinkedTourData = () => {
  const linkedTourStorage = sessionStorage.getItem(ONBOARDING_NEXT_TOUR_KEY);
  if (!linkedTourStorage) {
    return null;
  }
  const data = JSON.parse(linkedTourStorage);
  if (isStateExpired(data === null || data === void 0 ? void 0 : data.expires)) {
    return null;
  }
  return data;
};
export const getLinkedTourId = () => {
  var _getLinkedTourData;
  const tourId = (_getLinkedTourData = getLinkedTourData()) === null || _getLinkedTourData === void 0 ? void 0 : _getLinkedTourData.tourId;
  return (tourId === null || tourId === void 0 ? void 0 : tourId.split(':')[0]) || null;
};
export function isOnboardingTourCurrentlyActive(tourId = '') {
  const activeTourSelector = `body.onboarding-tour--active${tourId ? ` [data-tour-id="${tourId}"]` : ''}`;
  return document.querySelector(activeTourSelector) !== null;
}
export const shouldRenderOnboardingTour = () => {
  const tourIdFromQuery = getTourIdFromQueryParams();
  const linkedTourId = getLinkedTourId();
  return !!(tourIdFromQuery || linkedTourId);
};